{
  "version": "1",
  "name": "Control-Z gate",
  "register": [
    { "name": "target", "x": -2.0, "y": 0.0 },
    { "name": "control", "x": 2.0, "y": 0.0 }
  ],
  "channels": { "digital": "raman_local", "rydberg": "rydberg_local" },
  "variables": {},
  "operations": [
    { "op": "target", "channel": "digital", "target": 0 },
    { "op": "target", "channel": "rydberg", "target": 0 },
    {
      "op": "pulse",
      "channel": "digital",
      "protocol": "min-delay",
      "amplitude": { "kind": "blackman", "duration": 200, "area": 1.5707963267948966 },
      "detuning": { "kind": "constant", "duration": 200, "value": 0.0 },
      "phase": 4.71238898038469,
      "post_phase_shift": 0.0
    },
    { "op": "target", "channel": "digital", "target": 1 },
    {
      "op": "pulse",
      "channel": "digital",
      "protocol": "min-delay",
      "amplitude": { "kind": "blackman", "duration": 200, "area": 1.5707963267948966 },
      "detuning": { "kind": "constant", "duration": 200, "value": 0.0 },
      "phase": 1.5707963267948966,
      "post_phase_shift": 0.0
    },
    { "op": "align", "channels": ["digital", "rydberg"] },
    {
      "op": "pulse",
      "channel": "rydberg",
      "protocol": "min-delay",
      "amplitude": { "kind": "blackman", "duration": 200, "area": 3.141592653589793 },
      "detuning": { "kind": "constant", "duration": 200, "value": 0.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    },
    { "op": "target", "channel": "rydberg", "target": 1 },
    {
      "op": "pulse",
      "channel": "rydberg",
      "protocol": "min-delay",
      "amplitude": { "kind": "blackman", "duration": 725, "area": 6.283185307179586 },
      "detuning": { "kind": "constant", "duration": 725, "value": 0.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    },
    { "op": "target", "channel": "rydberg", "target": 0 },
    {
      "op": "pulse",
      "channel": "rydberg",
      "protocol": "min-delay",
      "amplitude": { "kind": "blackman", "duration": 200, "area": 3.141592653589793 },
      "detuning": { "kind": "constant", "duration": 200, "value": 0.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    },
    { "op": "align", "channels": ["digital", "rydberg"] },
    {
      "op": "pulse",
      "channel": "digital",
      "protocol": "min-delay",
      "amplitude": { "kind": "blackman", "duration": 200, "area": 1.5707963267948966 },
      "detuning": { "kind": "constant", "duration": 200, "value": 0.0 },
      "phase": 4.71238898038469,
      "post_phase_shift": 0.0
    }
  ],
  "measurement": "digital",
  "device": "MockDevice"
}
